var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"good-needs-main",class:{ 'good-needs-main-mobile': _vm.isMobile}},_vm._l((_vm.dataList),function(item){return _c('GoodNeedsItem',{key:item.key,attrs:{"data":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }